export const Heading = ({ children, ic: Ic, c }) => (
  <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 20, color: c.fg, display: "flex", alignItems: "center", gap: 8 }}>
    {Ic && <Ic size={15} style={{ color: c.blue }} />}
    {children}
  </div>
);
